export default __webpack_public_path__ + "static/media/google-play.6492b1d0.png";